import * as _ from "lodash-es";
import React, { Component } from "react";
import ExportTemplateEnum from "../../../models/ExportTemplateEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./ExportSidebar.scss";

type Props = {
    supplierModel: ISupplierModel;
    label?: string;
    items?: any[];
    submitFn?: (type: string, items: any[]) => void;
    clearAllFn?: () => void;
    // clearSingleFn: PropTypes.func,
    fieldTitle?: string;
    fieldProp?: string;
    cancel: (shouldBeVisible?: boolean) => void;
};

type State = {
    items?: any[];
    type?: string;
    hiddenItems: number;
};

class ExportSidebar extends Component<Props, State> {
    static defaultProps = {
        items: [],
    };

    readonly state: State = {
        items: this.props.items,
        hiddenItems: 0,
    };

    cancel = () => {
        // this.resetState();
        this.props.cancel(false);
    };

    save = () => {
        this.props.cancel();
    };

    clearAll = () => {
        if (this.props.clearAllFn) {
            this.props.clearAllFn();
        }
        this.props.cancel();
    };

    submit = () => {
        if (this.props.submitFn) {
            this.props.submitFn(this.state.type!, this.state.items!);
        }
        this.props.cancel();
    };

    handleChange = (e: any) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    markForDeletion = (index: number) => {
        const items = this.state.items!;

        items[index]["deleteFlag"] = true;

        this.setState({
            items,
        });
    };

    buildItemList = () => {
        return _.map(this.state.items, (item: any, index: number) => {
            if (!item.deleteFlag) {
                return (
                    <tr key={index}>
                        <td>
                            <i
                                className={"far fa-trash"}
                                onClick={() => {
                                    this.markForDeletion(index);
                                }}
                            />
                        </td>
                        <td>{item[this.props.fieldProp!]}</td>
                    </tr>
                );
            }
        });
    };

    buildItemTable = () => {
        if (this.state.items && this.state.items.length) {
            const itemsList = this.buildItemList();

            return (
                <table>
                    <thead>
                        <tr>
                            <th />
                            <th>{this.props.fieldTitle}</th>
                        </tr>
                    </thead>
                    <tbody>{itemsList}</tbody>
                </table>
            );
        } else {
            return <p>No Items Selected For Export</p>;
        }
    };

    render() {
        const itemTable = this.buildItemTable();

        const exportOptions: { value: ExportTemplateEnum; title: string }[] = [
            { value: ExportTemplateEnum.CSV, title: "CSV" },
            { value: ExportTemplateEnum.SAGE100, title: "Sage 100" },
            { value: ExportTemplateEnum.SAGE50, title: "Sage 50" },
            { value: ExportTemplateEnum.SIF, title: "SIF" },
        ];

        if (this.props.supplierModel.guid === "02d34dc4-d9e2-4af4-b76b-622844bacd4b") {
            exportOptions.push({ value: ExportTemplateEnum.FROMM, title: "FROMM Export" });
        }

        if (this.props.supplierModel.guid === "03caa05b-afcd-476c-9354-ded5d0dafa52") {
            exportOptions.push({ value: ExportTemplateEnum.BOERLIND, title: "Boerlind Export" });
        }

        return (
            <div className="ExportSidebar p-2">
                <div>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>

                    <OwTitle leftIconName={"fas fa-file-export"} title={"export"} />
                    <hr />
                </div>

                <div>
                    <OwLabel title={"type"} className={"me-2"} />

                    <OwSelectOption
                        name={"type"}
                        options={exportOptions}
                        selectedOption={this.state}
                        selectedOptionProp={"type"}
                        fn={this.handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                    />
                </div>

                <div>
                    <OwLabel title={this.props.label} className={"me-2"} />

                    {itemTable}
                </div>

                <div>
                    <OwButton fn={this.submit} title={"submit"} className={"btn-primary me-2"} />

                    <OwButton fn={this.cancel} title={"cancel"} className={"btn-primary me-2"} />

                    <OwButton fn={this.clearAll} title={"clear_all"} className={"btn-danger"} />
                </div>
            </div>
        );
    }
}

export default ExportSidebar;
